// removed by extract-text-webpack-plugin
module.exports = {"label":"magazines_11NwR","input":"magazines_ly3FF","wrapper-text-color__palette":"magazines_fMsfW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/FontColor/styles.scss
// module id = 1078
// module chunks = 1